import axios from 'axios';
import i18n from '@/i18n/index.js'
import Vue from 'vue';

// const url = "http://localhost/api/";
const url = "https://io.webshop.lan1.eu/api/"


  // Add a response interceptor
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if(error.toString()== "Error: Network Error"){
      Vue.swal({
        icon: 'error',
        title: i18n.t('error'),
        text: i18n.t('networkError')
      })
      return;
    }
    if(error.response.message == "Unauthenticated." ){
      Vue.router.push("/login");
      Vue.store.dispatch("doLogout")
    }
    if(error.status == 401){
      Vue.swal({
        icon: 'error',
        title: i18n.t('error'),
        text: i18n.t('noPermissions')
      })
      return;
    }
    if(error.response && error.response.data && error.response.data.message && error.response.data.message == "Token has expired"){
      Vue.router.push("/login");
      Vue.store.dispatch("doLogout")
    }
    return Promise.reject(error);
  });


export default {
  //
  getApiUrl() {
    return url;
  },

  //Auth
  postLogin(credentials) {
    return this.postCustom('auth/login', credentials); //Requires email, password
  },
  postLogout(credentials) {
    return this.postCustom('auth/logout', credentials);
  },
  postInform(credentials) {
    return this.postCustom('auth/inform', credentials);
  },
  postRefresh(credentials) {
    return this.postCustom('auth/refresh', credentials); //Requires email, password
  },
  requestToken(credentials){
    return this.postCustom('auth/requestToken', credentials);
  },
  changePassWithToken(credentials){
    return this.postCustom('auth/changePassWithToken', credentials);
  },
  putUpdateSelf(credentials){
    return this.putCustom("self", credentials)
  },
  //User
  getUserDropdown(){
    return this.getCustom("user_dropdown");
  },
  postUser(credentials){
    return this.postCustom("user", credentials)
  },
  postAdmin(credentials){
    return this.postCustom("admin", credentials)
  },
  getUser(id, credentials){
    return this.getCustom("user/" + id, credentials)
  },
  putUser(id, credentials){
    // console.log(credentials)
    // return;
    return this.putCustom("user/"+ id, credentials)
  },
  deleteUser(id, credentials){
    return this.deleteCustom("user/"+ id, credentials)
  },
  getUserDropdownGroup(id,credentials){
    return this.postCustom("user_dropdown/groups/"+id, credentials)
  },


  //Group
  postGroup(credentials){
    return this.postCustom("group", credentials)
  },
  getGroup(id, credentials){
    return this.getCustom("group/" + id, credentials)
  },
  putGroup(id, credentials){
    return this.putCustom("group/"+ id, credentials)
  },
  deleteGroup(id, credentials){
    return this.deleteCustom("group/"+ id, credentials)
  },
  getGroupDropdown(){
    return this.getCustom("group_dropdown");
  },
  groupTable(){
    return this.getCustom("groups");
  },
  getGroups(){
    return this.getCustom("getGroups");
  },
  addUserToGroup(id, credentials){
    return this.postCustom("group/"+id+"/addUser",credentials)
  },
  removeUserFromGroup(id, credentials){
    return this.postCustom("group/"+id+"/removeUser",credentials)
  },

  //Products
  postProducts(credentials){
    return this.postCustom("products", credentials)
  },
  getProduct(id, credentials){
    return this.getCustom("product/" + id, credentials)
  },
  postProduct(credentials){
    return this.postCustom("product", credentials)
  },
  putProduct(id, credentials){
    return this.putCustom("product/"+ id, credentials)
  },
  deleteProduct(id, credentials){
    return this.deleteCustom("product/"+ id, credentials)
  },
  addCategory(id, credentials){
    return this.postCustom("product/"+id+"/category", credentials)
  },
  removeCategory(id, credentials){
    return this.deleteCustom("product/"+id+"/category", credentials)
  },
  postSearchCatalog(credentials){
    return this.postCustom("products/search", credentials)
  },
  getExtrasDropdown(){
    return this.getCustom("extras_dropdown")
  },
  getExtras(id){
    return this.getCustom("product/"+id+"/extras")
  },
  postAddExtra(id, credentials){
    return this.postCustom("product/"+id+"/extra", credentials)
  },
  removeExtra(id){
    return this.deleteCustom("product/"+id+"/extra")
  },
  getProductDropdown(credentials){
    return this.postCustom("product_dropdown",credentials)
  },

  // Categories
  getCategories(credentials){
    return this.getCustom("category", credentials)
  },
  getCategory(id, credentials){
    return this.getCustom("category/" + id, credentials)
  },
  postCategory(credentials){
    return this.postCustom("category", credentials)
  },
  deleteCategory(id){
    return this.deleteCustom("category/"+id)
  },
  putCategory(id, credentials){
    return this.putCustom("category/"+ id, credentials)
  },
  sortByCategory(id, credentials){
    return this.getCustom("category/" + id + "/products", credentials)
  },
  sortByCategories(credentials){
    return this.postCustom("category/products", credentials)
  },
  addProducts(id, credentials){
    return this.postCustom("category/"+id+"/addProduct", credentials)
  },
  removeProduct(id, credentials){
    return this.postCustom("category/"+id+"/removeProduct", credentials)
  },


  // Cart
  addToCart(credentials){
    return this.postCustom("cart", credentials)
  },
  removeFromCart(id, credentials){
    return this.deleteCustom("cart/"+id, credentials)
  },
  clearCart(credentials){
    return this.deleteCustom("cart/clear", credentials)
  },
  getCart(credentials){
    return this.getCustom("cart", credentials)
  },
  editCartItem(id, credentials){
    return this.putCustom("cart/"+id, credentials)
  },
  postCheckoutAll(credentials){
    return this.postCustom("cart/checkout", credentials)
  },
  postCheckoutOne(id, credentials){
    return this.postCustom("cart/"+id+"/checkout",credentials)
  },
  getCheckedout(credentials){
    return this.getCustom("checkedout", credentials)
  },
  updateStatus(id, credentials){
    return this.postCustom("cart/"+id+"/status", credentials)
  },
  getNotifications(){
    return this.getCustom("getNotifications");
  },
  getCartAmount(){
    return this.getCustom("getCartAmount")
  },

  // Stats
  getStats(credentials){
    return this.getCustom("stats", credentials)
  },


  //Internals
  getDownload(target) {
    return axios.get(url + target, { responseType: 'arraybuffer' }).then(response => response).catch(e => e.response);
  },
  postDownload(target, credentials) {
    return axios.post(url + target, credentials, { responseType: 'arraybuffer' }).then(response => response).catch(e => e.response);
  },
  getCustom(target) {
    return axios.get(url + target).then(response => response).catch(e => e.response);
  },
  getCustomDropdown(target) {
    return axios.get(url + target).then(response => response.data).catch(e => e.response);
  },
  postCustom(target, credentials) {
    return axios.post(url + target, credentials).then(response => response).catch(e => e.response);
  },
  putCustom(target, credentials) {
    return axios.put(url + target, credentials).then(response => response).catch(e => e.response);
  },
  deleteCustom(target) {
    return axios.delete(url + target).then(response => response.status == 204).catch(e => e.response);
  },
  download(response, filename) {
    var newBlob = new Blob([response.data], { type: 'application/pdf' })

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob)
      return
    }

    const data = window.URL.createObjectURL(newBlob)
    var link = document.createElement('a')
    link.href = data
    link.download = filename + '.pdf'
    link.click()
    setTimeout(function () {
      window.URL.revokeObjectURL(data)
    }, 100)
  },
};